import { AppState } from "../../../../redux-configuration/AppState";
import { ChatMessage } from "../../../domain/entities/chatMessage";

export const loadPreviousChatMessagesLoadingSelector = (appState: AppState): boolean => appState.messaging.message.load.loading
export const loadPreviousChatMessagesErrorSelector = (appState: AppState): string | undefined => appState.messaging.message.load.error
export const previousChatMessagesSelector = (appState: AppState): ChatMessage[] | null => appState.messaging.message.load.messages
